import ModelUtil from '@leverege/model-util';
import MapViewerModel from "../../shared/models/MapViewerModel.js";
const TYPE = 'molten.GoogleMapViewerModel';
const STYLES = ['roadmap', 'hybrid', 'terrain', 'satellite'];
function create() {
  return {
    ...MapViewerModel.create(),
    mapId: null,
    mapTypeId: 'roadmap',
    renderingMode: 'overlaid',
    type: TYPE
  };
}
const def = {
  ...MapViewerModel
};
delete def.getMapStyleUrl;
export default {
  ...def,
  ...ModelUtil.createAllValue('mapTypeId'),
  getMapTypeId(model, override) {
    if (override && STYLES.includes(override)) {
      return override;
    }
    return model.mapTypeId;
  },
  ...ModelUtil.createAllValue('mapId'),
  ...ModelUtil.createAllValue('renderingMode'),
  ...ModelUtil.createAllValue('streetViewControl', null, null, {
    defaultValue: true
  }),
  TYPE,
  create,
  STYLES
};